import { useTokenStore } from '@/stores/token';
import type { JwtTokenContent } from '@/types/jwtToken';
import type { Token } from '@/types/token';
import toast from '@/utils/toast';
import { jwtDecode } from 'jwt-decode';

export function getJwtTokenContent(): JwtTokenContent {
    const token = localStorage.getItem('token');

    if (!token) return { employeeId: '', expiresInSeconds: 0, iat: 0 };

    let decodedJwtToken: JwtTokenContent;

    try {
        decodedJwtToken = jwtDecode<JwtTokenContent>(token);
    } catch (error) {
        console.error(error);
        return { employeeId: '', expiresInSeconds: 0, iat: 0 };
    }

    return decodedJwtToken;
}

export async function validateJwtToken(jwtTokenFromParams: string): Promise<Token | null> {
    try {
        const tokenStore = useTokenStore();

        const token = await tokenStore.fetchByJwtToken(jwtTokenFromParams);
        const jwtTokenContent = jwtDecode(jwtTokenFromParams) as JwtTokenContent;
        const currentTime = Math.floor(Date.now() / 1000);
        const timeDifference = currentTime - (jwtTokenContent.iat ?? 0);

        if (!jwtTokenContent) {
            toast.warning('InvalidLink');
            return null;
        }

        if (timeDifference > jwtTokenContent.expiresInSeconds) {
            toast.warning('LinkExpired');
            return null;
        }

        if (!token?.jwtToken) {
            toast.warning('LinkAlreadyUsed');
            return null;
        }

        return token;
    } catch (error) {
        console.error('Error validating token:', error);
        toast.error('LinkProblem');
        return null;
    }
}
